import enumPart from '@data/enumPart';

// util
import objectHelper from '@util/objectHelper';

let e = objectHelper.merge(enumPart, {

    WORD: {
        code: 'WORD',
        title: '文档'
    },
    TEACHING_PLAN: {
        code: 'TEACHING_PLAN',
        title: '教案'
    },
    COURSEWARE: {
        code: 'COURSEWARE',
        title: '课件'
    },
    COLLECTION: {
        code: 'COLLECTION',
        title: '合集'
    },
    TABLE: {
        code: 'TABLE',
        title: '表格'
    },
    POSTER: {
        code: 'POSTER',
        title: '海报'
    },
    SPEAK: {
        code: 'SPEAK',
        title: '话术'
    },

});

export default e;
